<ng-container *ngIf="iconOnly; else fullBadge">
	<span [class]="['rx-intuitive-indication-badge', 'rx-intuitive-indication-badge--icon-only', indicationClass]">
		<span class="rx-intuitive-indication-badge__icon" aria-hidden="true"></span>
	</span>
</ng-container>
<ng-template #fullBadge>
	<span
		tlk-badge
		[class]="['rx-intuitive-indication-badge', indicationClass]"
		textColor="light"
		[size]="size"
	>
		<span class="rx-intuitive-indication-badge__icon" aria-hidden="true"></span>
		{{ indication | indicationTranslate }}
	</span>
</ng-template>
